import { useEffect, useState } from 'react';
import Navbar from '../Components/NavBarV2';
import Lateral1 from '../images/lateral1.png';
import Lateral2 from '../images/lateral2.png';
import videoFondo from '../images/videoFondo.mp4';
import { db, storage } from '../Firebase/Firebase';
import { getDocs, collection, setDoc, doc, query, where, updateDoc, deleteDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject, listAll } from "firebase/storage";
import Modal from 'react-modal';
import './typeSpace.css'

const TypeSpace = () => {
    const [descripcion, setDescripcion] = useState("");
    const [tipoEspacio, setTipoEspacio] = useState("");
    const [tiposEspacio, setTiposEspacio] = useState([]);
    const [modalIsOpenUpdate, setIsEditModalOpen] = useState(false);
    const [modalIsOpenDelete, setModalIsOpenDelete] = useState(false);
    const [selectedEspacio, setSelectedEspacio] = useState(null);
    const [icono, seticono] = useState(null);
    const [iconoEspacio, seticonoEspacio] = useState(null); // Estado para el nuevo icono del espacio
    const [color, setColor] = useState("#fcbf49");


    // Función para generar un ID aleatorio para el espacio
    const generateRandomId = () => {
        return 'tipoEspacio_' + Math.random().toString(36).substr(2, 9);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        let iconoUrl = null;

        const newIdTipoEspacio = generateRandomId();
        // Subir el icono si se ha seleccionado
        if (icono) {
            const iconoName = `${newIdTipoEspacio}icono.png`;
            const iconoStorageRef = ref(storage, `Fotostiposespacios/${newIdTipoEspacio}/${iconoName}`);
            const iconoSnapshot = await uploadBytes(iconoStorageRef, icono);
            iconoUrl = await getDownloadURL(iconoSnapshot.ref);
        }
        const newData = {
            IdTipoEspacio: newIdTipoEspacio,
            TipoEspacio: tipoEspacio,
            DescripcionEspacio: descripcion,
            icono: iconoUrl,
            color: color
        };

        try {
            await setDoc(doc(db, "tipoespacio", newIdTipoEspacio), newData);
            setDescripcion('');
            setTipoEspacio('');
            seticono('');
            setColor('')
            fetchTipoEspacios();
            window.location.reload();
        } catch (error) {
            console.error("Error al registrar el espacio: ", error);
        }
    };
    const fetchTipoEspacios = async () => {
        const querySnapshot = await getDocs(collection(db, "tipoespacio"));
        const tiposEspacioData = querySnapshot.docs.map((doc) => doc.data());
        setTiposEspacio(tiposEspacioData);
    };

    // Obtener los tipos de espacio cuando el componente se monta
    useEffect(() => {
        fetchTipoEspacios();
    }, []);

    // Función para abrir el modal de edición
    const handleMarkerClick = (espacio) => {
        setSelectedEspacio(espacio);
        setTipoEspacio(espacio.TipoEspacio);
        setDescripcion(espacio.DescripcionEspacio);
        seticono(espacio.icono);
        setColor(espacio.color || "#fcbf49"); // Color guardado o uno predeterminado
        setIsEditModalOpen(true);
    };

    // Función para cerrar el modal
    const closeEditModal = () => {
        setIsEditModalOpen(false);
        setSelectedEspacio(null);
        setTipoEspacio("");
        setDescripcion("");
    };

    const closeModalUpdate = () => {
        setIsEditModalOpen(false);
        setSelectedEspacio(null);
        setTipoEspacio("");
        setDescripcion("");
    };
    // Función para manejar la edición de un tipo de espacio
    const handleEditSubmit = async (e) => {
        e.preventDefault();
        if (!selectedEspacio) {
            console.error("Error: selectedEspacio es null o undefined.");
            return;
        }

        let iconoUrl = selectedEspacio.icono || ""; // Mantiene la URL del icono existente

        if (icono) { // Solo sube el nuevo icono si se ha seleccionado
            const iconoName = `${selectedEspacio.IdTipoEspacio}icono.png`;
            const iconoStorageRef = ref(storage, `Fotostiposespacios/${selectedEspacio.IdTipoEspacio}/${iconoName}`);
            const iconoSnapshot = await uploadBytes(iconoStorageRef, icono);
            iconoUrl = await getDownloadURL(iconoSnapshot.ref);
        }

        const updatedData = {
            IdTipoEspacio: selectedEspacio.IdTipoEspacio,
            TipoEspacio: tipoEspacio,
            DescripcionEspacio: descripcion,
            icono: iconoUrl, // Mantiene o actualiza la URL del ícono
            color: color
        };

        try {
            await setDoc(doc(db, "tipoespacio", selectedEspacio.IdTipoEspacio), updatedData);
            closeEditModal();
            fetchTipoEspacios();
        } catch (error) {
            console.error("Error al actualizar el espacio: ", error);
        }
    };


    const openDeleteModal = (espacio) => {
        setSelectedEspacio(espacio);
        setModalIsOpenDelete(true);
    };

    const closeModalDelete = () => {
        setModalIsOpenDelete(false);
        setSelectedEspacio(null);
    };
    const handleDelete = async () => {
        if (selectedEspacio) {
            const espacioId = selectedEspacio.IdTipoEspacio;

            // Referencia a la carpeta que deseas eliminar
            const espacioStorageRef = ref(storage, `Fotostiposespacios/${espacioId}`);

            try {
                // Eliminar el documento de Firestore
                await deleteDoc(doc(db, "tipoespacio", espacioId));

                // Eliminar la carpeta del storage
                const listRef = ref(storage, `Fotostiposespacios/${espacioId}`);
                const list = await listAll(listRef);

                // Eliminar todos los objetos en la carpeta
                const deletePromises = list.items.map((itemRef) => deleteObject(itemRef));
                await Promise.all(deletePromises);

                closeModalDelete();
                fetchTipoEspacios();
            } catch (error) {
                console.error("Error al eliminar el espacio: ", error);
            }
        }
    };


    return (
        <div>
            <Navbar />

            <div className='center-header-type'>
                <img className='imagenlateral1' src={Lateral1} alt="Lateral" />
                <div className="Presentation">
                    <video className='video-background-type' src={videoFondo} autoPlay muted loop></video>
                    <div className="form-container-type">
                        <h2>Registrar Tipo de Espacio</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="form-row">

                                <div className="form-column">
                                    <p>Tipo del Espacio:</p>
                                    <input
                                        type="text"
                                        value={tipoEspacio}
                                        onChange={(e) => setTipoEspacio(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-column">
                                    <p>Descripción:</p>
                                    <textarea
                                        type="text"
                                        value={descripcion}
                                        onChange={(e) => setDescripcion(e.target.value)}
                                        required
                                    ></textarea>
                                </div>
                                <div className="form-column">
                                    <p>icono:</p>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => seticono(e.target.files[0])}
                                        required
                                    />
                                </div>
                                <div className="form-column">
                                    <p>Color:</p>
                                    <input
                                        type="color"
                                        value={color}
                                        onChange={(e) => setColor(e.target.value)}
                                        required
                                    />
                                </div>

                            </div>


                            <button className='btn-space-details' type="submit">Registrar Tipo de Espacio</button>

                        </form>
                    </div>
                </div>
                <img className='imagenlateral2' src={Lateral2} alt="Lateral" />
            </div>

            <div className="table-container-type">
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th className="table-header">TipoEspacio</th>
                            <th className="table-header">Descripción</th>
                            <th className="table-header">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tiposEspacio.length > 0 ? (
                            tiposEspacio.map((espacio) => (
                                <tr key={espacio.IdTipoEspacio} className="table-row">
                                    <td className="table-cell">{espacio.TipoEspacio}</td>
                                    <td className="table-cell">{espacio.DescripcionEspacio}</td>
                                    <td className="table-cell">
                                        <button onClick={() => handleMarkerClick(espacio)}>Editar</button>
                                        <button onClick={() => openDeleteModal(espacio)}>Eliminar</button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>
                                    No se encontraron tipos de espacio.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Modal
                isOpen={modalIsOpenUpdate}
                onRequestClose={closeModalUpdate}
                contentLabel=""
              
            >
                <h2>Editar Tipo de Espacio</h2>
                <form onSubmit={handleEditSubmit}>
                    <div>
                        <p>Tipo del Espacio:</p>
                        <input
                            type="text"
                            value={tipoEspacio}
                            onChange={(e) => setTipoEspacio(e.target.value)}
                            required
                        />
                    </div>
                    <div>
                        <p>Descripción:</p>
                        <textarea
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                            required
                        ></textarea>
                    </div>
                    <div>
                        <p>Icono del Espacio: </p>
                        {selectedEspacio && selectedEspacio.icono ? (
                            <img
                                src={selectedEspacio.icono}
                                alt="icono del espacio"
                                width="150px"
                                height="150px"
                                style={{ borderRadius: '8px' }}
                            />

                        ) : (
                            <p>No hay ningún icono disponible</p>
                        )}

                        <div style={{ marginTop: '-19px' }}>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => seticono(e.target.files[0])}

                            />
                        </div>

                    </div>
                    <div>
                        <p>Color:</p>
                        <input
                            type="color"
                            value={color}
                            onChange={(e) => setColor(e.target.value)}
                            required
                        />
                    </div>
                    <button
                        className="modal-button"
                        type="submit">Actualizar</button>
                </form>
                <button
                    className="modal-button"
                    onClick={closeModalUpdate} style={{ marginTop: '10px' }}>Cancelar</button>
            </Modal>

            <Modal
                isOpen={modalIsOpenDelete}
                onRequestClose={closeModalDelete}
                contentLabel="Confirmar Eliminación"            
            >
                <h2>¿Estás seguro que deseas eliminar este lugar?</h2>

                {/* Mostrar los detalles del lugar seleccionado */}
                {selectedEspacio && (
                    <div>
                        <p><strong>Tipo de Espacio:</strong> {selectedEspacio.TipoEspacio}</p>
                        <p><strong>Descripción:</strong> {selectedEspacio.DescripcionEspacio}</p>
                    </div>
                )}

                <p>Esta acción no se puede deshacer.</p>

                <button
                    style={{ backgroundColor: 'red', color: 'white', marginRight: '10px', padding: '10px 15px', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
                    onClick={handleDelete}
                    className="modal-button"

                >
                    Confirmar Eliminación
                </button>
                <button
                    onClick={closeModalDelete}
                    className="modal-button"

                >
                    Cancelar
                </button>
            </Modal>

        </div>

    );
};

export default TypeSpace;
